/* eslint-disable prettier/prettier */
export const endpoint = {
  // BASE_URL_STAGING:  window.location.origin,
  BASE_URL_STAGING: window.location.host === "localhost:3002" ? "http://localhost:4002": window.location.origin,
  // BASE_URL_STAGING: "https://devlms.iflhousingfinance.in",

  // Authentication / Authorization
  SIGN_IN: "los/public/v1/user/login",
  LOGOUT: "auth/v1/oauth/user/logout",
  USER_DETAIL: "core/v1/admin/user/detail",
  FILE_UPLOAD: "core/v1/file/upload",
  RETAIN_TOKEN: "auth/v1/oauth2/user/retain-token/",
  APP_URL: "/app/url-link",
  FEATURE_FLAG: "/app/feature-flag",
  WEB_SOCKET:"/app/ws-url",
  //ReceiptAndPAyment
  RECEIPT_DISBURSAL_PAYMENT: "los/v1/admin/loan/application/find",
  DISBURSAL_PAYMENT: "lms/v1/task/disbursement/findDisbursalDetail/",
  RECEIPT_NUMBER: "lms/v1/receipt/generateReceiptNum",
  LOGO_URL :"core/v1/link/logo-url",
  // APPLICANT_GETDATA:

  //Admin
  ADMIN_USER_AGENTS: "los/v1/admin/user/agents",
  ADMIN_FINDBYSTATUS: "los/v1/admin/loan/application/findByStatus",
  ADMIN_FINDBYBRANCHID: "los/v1/admin/loan/application/find-application?branchCode=",
  CUSTOMER_APPLICATIONFINDID: "los/v1/customer/loan/application/find?id=",
  ADMIN_LOANSCHEME_FIND: "core/v1/loan/scheme/find/",
  ADMIN_APPLICANTIONASSIGN: "los/v1/admin/loan/application/assign",
  ADMIN_GOLDRATE_FINDALL: "core/v1/admin/goldrate/findAll",
  ADMIN_GOLDRATE_FINDHISTORY: "core/v1/admin/goldrate/findHistory",
  ADMIN_GOLDRATE_FINDPURITY: "core/v1/admin/goldrate/find?purity=22k",
  ADMIN_GOLDRATEFIND: "core/v1/admin/goldrate/find?purity=",
  ADMIN_SILVERRATEFIND: "core/v1/admin/silver-rate/find?purity=",
  ADMIN_GOLDRATE_UPDATE: "core/v1/admin/goldrate/update",
  ADMIN_LOANSCHEME_CALCULATELTV: "core/v1/loan/scheme/calculateLtv",
  ADMIN_LOANAPPLICATION_FINDSTATUS_SUBITTED:
    "los/v1/admin/loan/application/findByStatus?status=SUBMITTED",
  ADMIN_LOANAPPLICATION_FINDSTATUS_ASSIGNED:
    "los/v1/admin/loan/application/findByStatus?status=ASSIGNED",
  ADMIN_LOANAPPLICATIONUNASSIGN: "los/v1/admin/loan/application/unassign",
  ADMIN_LOANAPPLICANTIONFINDBYSTATUS:
    "los/v1/admin/loan/application/findByStatus?status=",
  ADMIN_SCHEME_CHANNEL_ALL: "core/v1/loan/scheme-channel/findAll",
  FIND_ALL_BRANCH:"core/v1/branch/find",
  //Application
  ADMIN_STARTAPPLICATION_FINDBRANCHPINCODES:
    "los/v1/admin/pincode/findBranchPincodes/",
  ADMIN_STARTAPPLICATION_SUBMIT: "los/v1/customer/loan/application/submit",
  ADMIN_APPLICATION_ASSIGN: "los/v1/admin/loan/application/assign",
  ADMIN_APPLICANTION_STARTTASK: "los/v1/agent/loan/application/startTask",
  FIND_DOCUMENT_STATUS:"lms/v1/profile/find-restrictions",
  ADMIN_ADHAARCAPTCHA: "los/public/v1/identity/search/adhaar/captcha",
  ADMIN_VERFICAION_OTP: "los/v1/agent/loan/application/validateOtp",
  AADHAR_CONNECT: "core/v1/identity/search/adhaar/link",
  AADHAR_DETAILS: "core/v1/identity/search/adhaar/details",
  ADMIN_ADHAARVALIDATEOTP: "los/public/v1/identity/search/adhaar/validateOtp",
  ADMIN_ADHAARGENERATEOTP: "los/public/v1/identity/search/adhaar/generateOtp",
  ADMIN_VERFICATION_VERIFY: "los/public/v1/verfication/verify",
  ADMIN_VERFICATION_SENTOTP: "los/public/v1/verfication/sendOtp",
  APPLICANT_GETDATA: "los/v1/agent/loanapplicant/detail/get?applicationId=",
  APPLICANT_FINDSTATUS: "los/v1/admin/loan/application/find?status=",
  APPLICANT_DETAILS_FIND_STATUS: "los/v1/admin/loan/application/maker/find?status=",
  APPLICANT_FINDSTATUSSANCTIONED:
    "los/v1/admin/loan/application/find?status=SANCTIONED",
  ADMIN_APPLICANT_CREATE: "los/v1/agent/loanapplicant/detail/add",
  ADMIN_PROFILE_FIND_DOCUMENTNUMBER: "lms/v1/profile/find?documentNumber=",
  ORNAMENT_GETDATA: "los/v1/agent/loanapplicant/loandetail/get?applicationId=",
  ADMIN_ORNAMENT_CREATE: "los/v1/agent/loanapplicant/loandetail/add",
  ADMIN_SEARCH_PANCARD: "core/v1/identity/search/panCard/",
  ADMIN_UPDATE_PAN: "los/v1/agent/loanapplicant/pan/update",
  ADMIN_ONACTUALLOANAMOUNT: "los/v1/loan/scheme/calculate?amount=",
  BANKINFORMATION_GETDATA: "los/v1/agent/loanapplicant/bankdetail/get",
  BANKNFORMATION_CREATE: "los/v1/agent/loanapplicant/bankdetail/add",
  NOMINEE_GETDATA: "los/v1/agent/nominee/find/",
  NOMINEE_ADD: "los/v1/agent/nominee/add",
  REVIEW: "los/v1/agent/loanapplicant/detail/get?applicationId=",
  DECISION: "los/v1/loan/application/decision/find/",
  DECISION_ADD: "los/v1/loan/application/decision/add",
  DISBURSAL_GETDATA: "los/v1/loan/application/disbursaldetail/find/",
  DISBURSAL_APPLICATION_LMS: "los/v1/loan/application/disbursaldetail/disburse-to-lms/",
  DISBURSAL_CREATE: "los/v1/loan/application/disbursaldetail/create",
  DISBURSAL_UPDATE: "lms/v1/task/disbursement/disbursaldetail/update",
  DISBURSAL_RESEND_OTP: "los/v1/loan/application/disbursaldetail/resend-otp/",
  DISBURSAL_VALIDATE_OTP: "los/v1/loan/application/disbursaldetail/validate-otp",
  FIND_LOAN_SATUS: "lms/v1/loan/search",
  DISBURESAL_CALCULATENETPAYABLE:
    "los/v1/loan/application/disbursaldetail/calculateNetpayable",
    DISBURSAL_SCHEME_CHARGES: "los/v1/loan/application/disbursaldetail/v2/calculate/scheme-charges/",
    DISBURSAL_CASH_CHARGES: "los/v1/loan/application/disbursaldetail/calculate/cashdisbursal/charges/",
     COLLATERAL_NEXT_MOVEMENT: "lms/v1/loan/collateral/find-next-movement/",
  ADMIN_DOCUMENT_UPDATELINKS:
    "los/v1/loan-application/document/update-document-links",
    FIND_DOUMENTS:"los/v1/loan-application/document/find/",
  USER_FIND_ALL: "core/v1/admin/user/findAll",

  ADMIN_FILE_UPLOADFILE: "public/v1/goldloan/file/uploadFile",
  ADMIN_CREATEPROFILE: "lms/v1/profile/createProfile",
  ADMIN_LOANACCOUNTNUMBER: "los/v1/applicant/profile/loanAccountNumber",
  SANCTION_LETTER: "los/v1/agent/loanapplicant/sanctionLetter/",
  GENERATE_NEW_SANCTION_LETTER:"los/v1/loan-application/document/generate/sanction-letter/",
  GENERATE_SANCTION_LETTER_UPDATED:"/los/v1/loan-application/document/generate/sanction/",
  ESIGN_SANCTION_LETTER:"los/v1/loan-application/esign/sanction-letter/",
  ADMIN_ESIGN:
    "los/v1/agent/loanapplicant/sanction/is-eSigned?loanApplicationId=",
  ADMIN_CALCULATE_ELIGIBLE_AMOUNT:
    "los/v1/agent/ornament/calculate/eligibleloanamt",
  ADMIN_CALCULATE_ELIGIBLE_AMOUNT_ALL_PRODUCTS:
    "los/v1/agent/ornament/calculate/loan/eligibleloanamt",
  ADMIN_CALCULATE_ELIGIBLE_AMOUNT_SILVER:
    "los/v1/agent/ornament/calculate-silver/eligibleloanamt",
  SANCTION_STATUS_UPDATE: "los/v1/agent/loan/application/status/update",
  SANCTIONLETTER_UPDATE: "los/v1/agent/loanapplicant/sanctionLetter/update",
  GENERATE_SANCTIONLETTER:
    "los/v1/agent/loanapplicant/generate/sanctionLetterUltradox?applicationId=",
  STATUS_SANCTIONlETTER: "los/v1/agent/loanapplicant/generate/sanctionLetterUltradox/",
  LOAN_CLOSURE_DUES: "lms/v1/loan/findLoanDues",
  APPLICANT_EMAIL_OTP: "core/v1/verfication/sendOtp",
  APPLICANT_EMAIL_VERIFY: "core/v1/verfication/verify/",
  LOAN_STATUS: "los/v1/loanApplication/find/application-type/",
  DOCUMENT_URL:"core/v1/link/download?url=",
  AADHAR_WITH_CAPTCHA:"core/v1/identity/search/adhaar/captcha",
  AADHAR_WITH_CAPTCHA_GENERATE_OTP:"core/v1/identity/search/adhaar/generateOtp",
  AADHAR_WITH_CAPTCHA_VALIDATE_OTP:"core/v1/identity/search/adhaar/validateOtp",
  // Bank Loan Account Number Controller
  PENNY_DROP: "core/v1/pennydrop/verify/bank-account",
  IFSC_CODE: "core/v1/pennydrop/ifsc/",
  OTP_CODE: "core/v1/pennydrop/validate-otp",
  RESEND_OTP: "core/v1/pennydrop/resend-otp/",
  APPLICANT_LAON_ID:"los/v1/loanApplication/loan-account-number?loanAccountNumber=",
  // State Master
  MASTER_STATE_FINDALL: "core/master/state/findAll",

  // Lead Report Count
  LEAD_REPORT_COUNT: "los/v1/loanApplication/count",
  LEAD_REPORT_DATA: "los/v1/admin/loan/application/find-application?status=",

  //lender Details
  Lender_details_post:"los/v1/applicant/lender/create",
  lender_details_get:"los/v1/applicant/lender/find/",

  //Pawan Ticket Details
  PawanTicket_Detials_post:"los/v1/applicant/pawan-ticket/create",
  PawanTicket_Detials_get:"los/v1/applicant/pawan-ticket/find/",

  //Affidavite

  VERNACULAR_DOCUMENT:"los/v1/loan-application/document/generate/vernacular-language",
  SIGN_DOCUMENT:"los/v1/loan-application/document/generate/sign-affidavit",
  NAME_DOCUMENT:"los/v1/loan-application/document/generate/name-affidavit",
  DOB_DOCUMENT:"los/v1/loan-application/document/generate/dob-affidavit",

  //BT Kit
  BT_KIT: "los/v1/loan-application/document/generate/bt-loan-kit/",
  CHECK_LOAN_STATUS: "lms/v1/loan/find",

   //Ornament
   STONE_WEIGHT:"core/v1/standard/deduction/master/calculate",
   ORNAMENT_LIST_DATA:"core/v1/ornament/master/find?ornamentEligiblity=ACCEPTABLE&ornamentMasterStatus=ACTIVE",
   CALCULATE_WEIGHT: "core/v1/utility/gold-purity/calculate-weight",
   CALCULATE_WEIGHT_SILVER: "core/v1/utility/purity/calculate-weight",
   REPLEDGE_GET_ORNAMENT: "los/v1/agent/ornament/findOrnament/",
   SCHEME_DETAILS_FIND: "los/v1/loan/application/scheme/find/",
   PACKET_ASSIGNED:"core/v1/packet-inventory/assign",
   PACKETS_SERIAL_NUMBER:"core/v1/allocated-packet-inventory/find-available/",
   PACKET_NUMBER_FINDALL: "core/v1/packet-inventory/findAll",
   PACKET_NUMBER_UPDATE: "core/v1/packet-inventory/update/",
   PACKET_NUMBER_DELETE: "core/v1/packet-inventory/delete/",
   LENDER_FINDALL: "core/v1/lender-master/find-all",
   RELATIONSHIP_FINDALL: "core/v1/relationship-master/findAll",
   SEARCH_PROFILE: "lms/v1/profile/search-profile?inputs=",
   CHECK_PROFILE_RESTRICTION: "lms/v1/profile/restriction/",
   FIND_DIGILLANCE: "core/v1/duediligence/findAll",
   UNASSIGN_PACKETS: "core/v1/packet-inventory/unassignPacket",
   SHOW_MASKED : "lms/v1/loan/find/",
   PERSONAL_LOAN_ELEGIBLITY: "los/v1/loanapplication/pl/",
   //collateral evaluation approval
   COLLATERAL_EVALUATION_SEARCH:"los/v1/loan-application/approval/search",
   COLLATERAL_EVALUATION_AUTHORIZE:"los/v1/loan-application/approval/authorize",
   COLLATERAL_EVALUATION_STATUS:"los/v1/loan-application/approval/details/",
   COLLATERAL_EVALUATION_HISTORY:"los/v1/loan-application/approval/history/",
   SANCTION_UPDATED_CHANGE_STATUS:"los/v1/agent/loanapplicant/sanction/",
   MASTER_HIERARCHY_FIND_BY_CODE: "core/master/hierarchy/findAll",
   
   //Sanction Letter part-b
   SANCTION_LETTER_CREATE_PART_B:"los/v1/loan-application/document/generate/sanction/",
   //find all document name
    GET_ALL_DOCUMENT_NAMES:"core/v1/common/document/findAll",
    ESTAMP_SANCTION_LETTER: "los/v1/loan-application/estamp/sanction-letter/",

    CHECK_PERSONAL_LOAN_DATA:"lms/v1/loan/external/task/find/status/",
    TOTAL_LOAN_IN_YEAR: "lms/v1/customer/",
    RECEIPT_FINDLOANSTANDING: "lms/v1/loan/findLoanOutstanding",
    FIND_LOAN_CHARGES:"los/v1/loan/application/disbursaldetail/v2/calculate/scheme-charges/",
    FIND_MAX_ROI_INTEREST_DATE:"lms/v1/loan/adjusment/prerequisite/",
    CALCULATE_INSURANCE_PREMIUM:"los/v1/loan/applicant/insurance/premium/calculate-premium/",
    GET_INSURANCE_PREMIUM:"los/v1/loan/applicant/insurance/premium/find/",
    GENERATE_INSURANCE_LETTER:"los/v1/loan-application/document/generate/insurance/",
    GET_ESIGN_INSURANCE_LETTER:"los/v1/loan-application/esign/insurance-letter/",
    NEW_PAN_CARD_VERIFY:"core/v1/identity/search/panCard/verify",
    CHECK_FOR_INSURANCE:"los/v1/loan/application/scheme/find/",
    CHECK_THIRD_PARTY_INTEGRATION:"core/v1/thirdparty/integration/master/findAll",
    UPDATE_CUSTOMER_PAN_DETAILS:"lms/v1/profile/",
    OTP_VALIDATE_ESIGN:"los/v1/loan-application/esign/validateOtp",
    RESEND_OTP_ESIGN:"los/v1/loan-application/esign/resend-otp/",
    SEARCH_PERSONAL_LOANS:"pls/v1/lead/search?status=",
    GET_INCOME_DETAILS:"pls/ploan/income-detail/findByLead/",
    GET_GENERAL_DETAILS:"pls/v1/applicant/detail/find/",
    GET_REFERENCE_DETAILS:"pls/v1/lead/referal/find/",
    GET_LOAN_AND_SCHEME_DETAILS:"pls/v1/loan/lead/interest/find/",
    GET_DOCUMENT_DETAILS:"pls/v1/lead-application/document/find/",
    GET_REPAYMENT_DETAILS:"pls/v1/lead/repayment/calculateAndUpdate/",
    GET_ADDRESS_DETAILS:"pls/v1/applicant-address/find/",
    GET_USER_LEAD_DETAILS:"pls/v1/lead/find/",
    GET_USER_BANK_DETAILS:"pls/v1/applicant/bank/find/",
    GET_USER_ADHAAR_DETAILS:"pls/v1/adhaar-kyc/details/",
    GET_USER_PHOTO_DETAILS:"pls/v1/applicant/photo/find/",
    GET_ALL_ORNAMENT_DATA:"los/v1/customer/ornaments",
    GET_ALL_LEAD_DETAILS:"pls/v1/lead/details/find/",
    APPLICATION_SEARCH:"los/v1/loanApplication/search?",
    AADHAR_INIT:'core/v1/identity/search/adhaar/init',
    GET_CASH_DETAILS_IN_YEAR:"lms/v1/loan/cash/validate/",
    GET_ALL_SUM_INSURED_VALUES:"core/v1/insurance/suminsured/master/findAll",
    ADMIN_CREATE_PROFILE_NEW:"los/v1/applicant/profile/create/",
    FACE_LIVENESS_INIT:"core/v1/faceliveness/init",
    FACEE_LIVENESS_FETCH_DATA:"core/v1/faceliveness/fetch/",
    UI_RESTRICTION_FIND:"core/v1/ui/restriction/find?",
    DISCREPANCY_DESCISION_STATUS:"los/v1/loan/app/coll/discrep/task/authorize",
    DISCREPANCY_DECEISION_GET_ID:"los/v1/loan/app/coll/discrep/task/search?status=ENTERED&loanApplicationId=",
    // ORNAMENT_MATCH_API:"lms/v1/loan/ornament/match",
    CHECK_FACE_MATCH:"core/v1/facematch/perform",
    CHECK_FOR_REPLEDGE_ACCOUNT_NUMEBR:"los/v1/loanApplication/prepledge?",
    CREATE_REQUEST_DIGIO:"/client/kyc/v2/request/with_template",
    GET_DIGIO_DOCUMENT_ID:"/client/kyc/v2/",
    GET_DIGIO_GET_MEDIA:"/client/kyc/v2/media/",
    GET_LOAN_TOP_AND_RENEAL_DETAILS:"los/v1/customer/loan/application/outstanding/",
    BT_KIT_LETTER_ESIGN:"los/v1/loan-application/esign/bt-kit/",
    BT_KIT_VALIDATE_OTP:"los/v1/loan-application/esign/validateOtp",
    BT_KIT_GET_ESIGN_LETTER:"los/v1/loan-application/esign/bt-kit/",
    BT_KIT_LETTER_RESEND_OTP:"los/v1/loan-application/esign/resend-otp/",
    DEVIATION_FINDALL: "core/v1/deviation/master/findAll",
    CREATE_REPAYMENT_SCHEDULE: "los/v1/loan/application/repayment/schedule/calculate/",
    FIND_REPAYMENT_SCHEDULE:"los/v1/loan/application/repayment/schedule/find/",
    DEVIATION_STATUS_UPDATE:"los/v1/loan/application/deviation/authorize",
    DEVIATION_SEARCH:"los/v1/loan/application/deviation/search",
    DEVIATION_VALIDATE:"los/v1/loan/application/deviation/validateDeviation/",
    COLLATERAL_APPROVAL_UPDATE_STATUS:"los/v1/loan/app/coll/discrep/task/authorize",
    COLLATERAL_APPROVAL_SEARCH:"los/v1/loan/app/coll/discrep/task/search",
    COLLATERAL_APPROVAL_VALIDATE:"los/v1/loan/app/coll/discrep/task/validateCollDescripency/",
    LEAD_VALIDATION_MASTER:"core/v1/lead/validation/master/findActive?validationName=",
    CALCULATE_PROCESSING_FEE:"los/v1/loan/application/disbursaldetail/calculate/scheme/charges",
    DEVIATION_HISTORY:"los/v1/loan/application/deviation/approval/history?loanApplicationId=",
    GET_ADJUSTED_LOAN_DATA:"lms/v1/loan/appication/detail/find?loanAccountNumber=",
    AUCTION_RESERVE_PRICE: "lms/v1/loan/ornament/reservePrice/",
    CHECK_NEGATIVE_REGISTER:"core/v1/customer/negative/registry/master/find",
    AUCTION_SEARCH:"lms/v1/auction/search",
    GET_LOAN_DETAILS:"lms/v1/loan/detail/findBasicDeatil?loanAccountNumber=",
    LOAN_MARKING_OUTSTANDING: "lms/v1/loan/marking/findLoanOutstanding?loanAccountNumber=",
    KYC_APPROVAL_API_CREATE:"los/v1/kyc/approval/create",
    KYC_APPROVAL_API_STATUS:"los/v1/kyc/approval/search?loanApplicationId=",
    GET_ALL_DATA_MOBILE_NUMBER:"lms/v1/customer/loans/eligibility",
    FAMILY_DETAIL_BASE_URL:"los/v1/loan/application/familydetail/",

    //Credit Assessment
    CREDIT_ASSESSMENT_GENERATE:"los/v1/loan-application/document/generate/credit-assessment/",
    CREDIT_ASSESSMENT_INITIATE:"los/v1/loan-application/esign/credit-assessment/",
    CREDIT_ASSESSMENT_DATA_FIND:"los/v1/loan/application/credit-assessment/find/",
    CREDIT_ASSESSMENT_DATA_CREATE:"los/v1/loan/application/credit-assessment/create",
    GET_CREDIT_SCORE_AND_EMI:"los/v1/applicant/cibil/score/",

    //Master Data
    MASTER_DATA_BY_CATEGORY_CODE:"core/v1/master/data?code=SOURCE_OF_REPAYMENT_OF_LOAN",
    FOIR_MASTER_FIND_ALL:"core/v1/master/foir-config/find-all",
    CHECK_ADDITIONAL_COLLATERAL_TYPE:"lms/v1/customer/collateral/validate",
    GET_AADHAR_DETAILS:"los/v1/agent/loanapplicant/aadhaar-detail/find?loanApplicationId=",
    GET_EKYC_DETAILS:"core/v1/identity/search/ekyc-detail/",
    AADHAR_PHOTO_MASKED:"core/v1/kyc/document/mask",
    EXPOSURE_AMOUNT_GET:"lms/v1/customer/loan/eligibility/ltv/calculate",
    GET_LOAN_AMOUNT_BY_CUST_ID: "lms/v1/customer/{customerId}/total-loan?loanAccountNumber={loanAccountNumbers}",
    MASTER_DATA_DOCUMENT_LIST:"core/v1/master/data?code=DOCUMENT_LIST",
    GET_CIBIL_OBILIGATION_DETAILS:"los/v1/applicant/cibil/detail/",
    GET_LOAN_ELIGIBLITY_DETAILS:"lms/v1/customer/loan/eligibility/calculate",
    UPDATED_LEAD_LOAN_APPLICATION:"los/v1/loanApplication/update/",
    MULTI_ESIGN_LETTER_BT_CASE:"los/v1/loan-application/esign/multi-signer/bt-kit/",
    GET_MULTI_ESIGN_LETTER:"los/v1/loan-application/esign/multi-signer/bt-kit/",
    CHECK_LOAN_MARKING:"lms/v1/customer/validation/validate/loan-marking?customerId=",
    SEND_BACK_BY_ID:"los/v1/loan/application/disbursaldetail/sendback/",
    FIND_WEB_SCOKET_MESSAGE:"lms/v1/customer/notification/find",
    STATUS_WEB_SOCKET_MESSAGE_UPDATE:"lms/v1/customer/notification/update/read",
    GET_LOAN_SENDBACK_HISTORY:"los/v1/loanApplication/find/stageHistory/",
    GET_WEB_SOCKET_NOTIFICATION:"core/v1/notification/my",
    UPDATE_WEB_SOCKET_NOTIFICATION_STATUS:"core/v1/notification/",
    GET_DIAMOND_CARET_AMOUNT:"core/v1/diamond/rate/search",
    FIND_PRODUCT_TYPE_ALL:"core/v1/product/findAll",
};
